{
  "reports": {
    "status": {
      "not_found": "No Report Found"
    },
    "actions": {
      "save_report": "Save Report",
      "edit_report": "Edit Report",
      "discard_changes": "Discard changes"
    },
    "info": {
      "created_by": "Created by:",
      "created_on": "Created on:",
      "last_updated": "Last updated:"
    },
    "fields": {
      "report_title": "Report Title"
    },
    "confirmations": {
      "discard_all_title": "Discard all changes",
      "discard_all_content": "Are you sure you want to discard the changes to the report?",
      "exit_edit_mode": "Exit Edit Mode"
    }
  },
  "sections": {
    "all_sections": "All Sections",
    "create_section": "Create Section",
    "back_to_all_sections": "Back to All Sections",
    "actions": {
      "save_changes": "Save changes",
      "discard_changes": "Discard changes",
      "edit_section": "Edit section",
      "delete_section": "Delete section"
    },
    "file_summary": {
      "replace_file": "Replace File",
      "replace_file_warning": "Once you click on regenerate, the file will be replaced and you won't be able to revert the changes.",
      "regenerate": "Regenerate"
    },
    "fields": {
      "ai_prompt": "AI Prompt",
      "section_title": "Section Title",
      "sources": "Sources"
    },
    "confirmations": {
      "discard_title": "Discard section changes",
      "discard_content": "Are you sure you want to discard the changes to this section?"
    },
    "types": {
      "add_blank_section": "Add Blank Section",
      "blank_section": "Blank Section",
      "blank_section_description": "Start with an empty rich text editor only",
      "file_summary": "File Summary",
      "file_summary_description": "Upload a file to summarise document using AI prompts",
      "ai_web_search": "AI Web Search",
      "ai_web_search_description": "Search across publicly available websites to find relevant content for your report.",
      "nexl_data": "Nexl Data",
      "nexl_data_description": "Select section type and generate content using Nexl data"
    }
  },
  "status": {
    "success": {
      "title": "Successfully generated!"
    },
    "error": {
      "title": "An error occurred while generating the section.",
      "description": "Please try again later or contact support if the issue persists."
    },
    "loading": {
      "title": "Generating section content...",
      "description": "This may take a moment."
    },
    "alt": {
      "title": "Generating section content...",
      "description": "This may take a moment."
    }
  },
  "agent-state": {
    "connecting": "Connecting to AI agent...",
    "disconnecting": "Disconnecting from AI agent...",
    "disconnected": "Apologies, our AI seems to be offline. Please refresh the page and try again. If the issue persists, please contact your Administrator.",
    "error": "Apologies, there seems to be an error with our AI. Please refresh the page and try again. If the issue persists, please contact your Administrator."
  },
  "validation": {
    "report_title_required": "Report title is required",
    "section_title_required": "Section title is required"
  },
  "prompt_library": {
    "title": "Prompt Library",
    "info": {
      "data_source": "Data Source",
      "created_at": "Created At",
      "error": "Error",
      "no_prompts": "No prompts found",
      "all_tags": "All tags"
    },
    "actions": {
      "create_new_tag": "Create new tag",
      "filter": "Filter",
      "create_prompt": "Create Prompt",
      "edit": "Edit Prompt",
      "delete": "Delete Prompt"
    },
    "placeholders": {
      "prompt_search": "Search by category, prompt title"
    },
    "aria_labels": {
      "prompt_search": "Search prompts by category or title"
    }
  }
}
